import { analytics, globalObservability } from '@opendoor/observability';
import { createListenerMiddleware, TypedStartListening } from '@reduxjs/toolkit';

import { showPrompt } from 'src/helpers/showPrompt';
import { errorPagePath } from 'src/routes/pathBuilders';

import { AppDispatch, RootState } from './';

const listenerMiddleware = createListenerMiddleware({
  onError: (error, errorInfo) => {
    // eslint-disable-next-line no-console
    console.error(`listenerMiddleware/error: ${error}`, errorInfo);

    const path = window.location.pathname.split('/');
    const slug = path.pop() ?? '';
    const leadToken = path[2] ?? 'n/a';

    analytics.trackEvent('flow-state', 'change', 'exception');
    if (globalObservability.isInitialized()) {
      const sentry = globalObservability.getSentryClient();
      if (sentry.withScope) {
        sentry.withScope((scope) => {
          scope.setTags({
            action: errorInfo.raisedBy,
            code: 'reception-listener-middleware',
            level: 'fatal',
          });
          scope.setExtras({ seller_input_uuid: leadToken, slug });
          if (sentry.captureException) {
            sentry.captureException(error);
          }
        });
      }
    }

    //when we get errors here we have received an exception in the one of our listeners,
    //we can't really be sure that the user can continue so we should bail to the error page
    setTimeout(() => {
      window.removeEventListener('beforeunload', showPrompt);
      window.location.href = errorPagePath({
        slug,
        page: 'flow-page',
        leadToken,
        code: 'unhandled',
      });
    }, 800);
  },
});

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

// `as unknown is needed?`
export const startAppListening = listenerMiddleware.startListening as unknown as AppStartListening;

export default listenerMiddleware;
